/**
 * Google API Keys Adapter
 * (this is the `connect` version of reconnect/src/config/apiKeys.ts, see there for more detail)
 *
 * Centralized adapter for accessing Google API keys from environment variables.
 * This provides isolation and a single source of truth for Google API key configuration.
 *
 * Benefits:
 * - Single point of configuration
 * - Easy to mock for testing
 * - Validation and error handling
 * - Type safety through consistent interface
 */

/**
 * Get Google Maps API key
 * @returns {string} Google Maps API key
 * @throws {Error} If API key is not set
 */
function getGoogleMapsApiKey() {
  // In browser environment, use App.googlePlacesApiKey (set via App.setup() in application.ejs)
  // In Node.js environment (server-side), use process.env
  var apiKey;
  const isBrowser = typeof window !== 'undefined';
  const isNode = typeof process !== 'undefined' && process.env && !isBrowser;

  if (isBrowser) {
    if (window.App && window.App.googlePlacesApiKey) {
      apiKey = window.App.googlePlacesApiKey;
    }
  } else if (isNode) {
    apiKey = process.env.GOOGLE_PLACES_API_KEY;
  }

  if (!apiKey) {
    // In test/Cypress environment, return a test key instead of throwing
    if (process.env.NODE_ENV === 'test' || (typeof window !== 'undefined' && window.Cypress)) {
      return 'test-google-places-api-key';
    }
    throw new Error(
      'GOOGLE_PLACES_API_KEY is required but not set. Autocomplete suggestions will not work.',
    );
  }

  return apiKey;
}

/**
 * API Keys Adapter
 */
const apiKeys = {
  getGoogleMapsApiKey,
};

module.exports = apiKeys;
